import { Component, OnInit, Inject, EventEmitter, Output, DOCUMENT } from '@angular/core';

import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';

import { LanguageService } from '../../core/services/language.service';
import { environment } from 'src/environments/environment';
import { AuthfakeauthenticationService } from '../../core/services/authfake.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UsersGridService } from 'src/app/pages/users-grid/users-grid.service';
import { AuthGuard } from 'src/app/account/auth/app.gaurd';
import { helperService } from 'src/app/utils/helper';
import { Notification } from '../../features/notifications/models/notification.models';
import { ThemeService } from '../../core/services/theme.service';

@Component({
    selector: 'app-topbar',
    templateUrl: './topbar.component.html',
    styleUrls: ['./topbar.component.scss'],
    standalone: false
})
/**
 * Topbar component
 */
export class TopbarComponent implements OnInit {
  // v13-migration placeholder (Ivy basic template-check requires the symbol to exist; undefined at runtime == v12 behaviour; Phase 2: align template)
  largeDataModal: any;

  element: any;
  flagvalue: any;
  cookieValue: any;
  countryName: any;
  valueset: any;
  user:any;
  userName:any;
  userDialog:Boolean=false;
  isProdEnv: boolean = environment.production;

  // Notification properties
  showNotificationDropdown: boolean = false;

  constructor(@Inject(DOCUMENT) private document: any,
    private router: Router,
    public languageService: LanguageService,
    public _cookiesService: CookieService,
    private auth: AuthGuard,
    private modalService : NgbModal,
    private userService : UsersGridService,
    private helperService:helperService,
    public themeService: ThemeService
  ) { }

  /***
   * Language Listing
   */
  listLang = [
    { text: 'English', flag: 'assets/images/flags/us.jpg', lang: 'en' },
    { text: 'Spanish', flag: 'assets/images/flags/spain.jpg', lang: 'es' },
    { text: 'German', flag: 'assets/images/flags/germany.jpg', lang: 'de' },
    { text: 'Italian', flag: 'assets/images/flags/italy.jpg', lang: 'it' },
    { text: 'Russian', flag: 'assets/images/flags/russia.jpg', lang: 'ru' },
  ];
  roles:any;

  @Output() settingsButtonClicked = new EventEmitter();
  @Output() mobileMenuButtonClicked = new EventEmitter();
  
  ngOnInit(): void {
    console.log(" isProdEnv "+ environment.production);

    this.roles = this.userService.roles;
    this.element = document.documentElement;
    // Cookies wise Language set
    this.cookieValue = this._cookiesService.get('lang');
    const val = this.listLang.filter(x => x.lang === this.cookieValue);
    this.countryName = val.map(element => element.text);
    if (val.length === 0) {
      if (this.flagvalue === undefined) { this.valueset = 'assets/images/flags/us.jpg'; }
    } else {
      this.flagvalue = val.map(element => element.flag);
    }
    this.userName=this.auth.jwtData.given_name;
    this.openProfileModal(null,true)
  }

  /***
   * Language Value Set
   */
  setLanguage(text: string, lang: string, flag: string) {
    this.countryName = text;
    this.flagvalue = flag;
    this.cookieValue = lang;
    this.languageService.setLanguage(lang);
  }

  /**
   * Fullscreen method
   */
  fullscreen() {
    document.body.classList.toggle('fullscreen-enable');
    if (
      !document.fullscreenElement && !this.element.mozFullScreenElement &&
      !this.element.webkitFullscreenElement) {
      if (this.element.requestFullscreen) {
        this.element.requestFullscreen();
      } else if (this.element.mozRequestFullScreen) {
        /* Firefox */
        this.element.mozRequestFullScreen();
      } else if (this.element.webkitRequestFullscreen) {
        /* Chrome, Safari and Opera */
        this.element.webkitRequestFullscreen();
      } else if (this.element.msRequestFullscreen) {
        /* IE/Edge */
        this.element.msRequestFullscreen();
      }
    } else {
      if (this.document.exitFullscreen) {
        this.document.exitFullscreen();
      } else if (this.document.mozCancelFullScreen) {
        /* Firefox */
        this.document.mozCancelFullScreen();
      } else if (this.document.webkitExitFullscreen) {
        /* Chrome, Safari and Opera */
        this.document.webkitExitFullscreen();
      } else if (this.document.msExitFullscreen) {
        /* IE/Edge */
        this.document.msExitFullscreen();
      }
    }
  }

  /**
   * Toggle the menu bar when having mobile screen
   */
  toggleMobileMenu(event: any) {
    event.preventDefault();
    this.mobileMenuButtonClicked.emit();
  }

  /**
   * Toggles the right sidebar
   */
  toggleRightSidebar() {
    this.settingsButtonClicked.emit();
  }
  
  openProfileModal(largeDataModal: any,checkUpdates?:Boolean) {
    this.userService.getLoginUser().subscribe(res => {
      this.user = res.rows;
      // this.userDialog=true;
      if(checkUpdates && res.rows && res.rows.updatedOn){
        let days=this.helperService.getDayDiff(new Date(res.rows.updatedOn),new Date());
        if(days>=90){
          this.userDialog=true;
        }
      }else{
        this.userDialog=true;
      }
      // this.modalService.open(largeDataModal, { size: 'xl', windowClass: 'modal-holder', centered: true });
    })
  }

  closeDialog():void{
    this.userDialog=false;
  }

  viewProfile() {
    // this.child.viewProfile(this.user);
    // this.profileButtonClicked.emit();
  }
  logout(){
    this.clearLocalStorage();
    this.auth.keycloak.logout(window.location.origin);
  }

  clearLocalStorage(){
    for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        if (key && key.startsWith('agilelegal_')) {
            localStorage.removeItem(key);
            // Decrement i as the length of localStorage changes after removing an item
            i--; 
        }
    }
  }

  // Notification methods
  onNotificationIconClick(): void {
    this.showNotificationDropdown = !this.showNotificationDropdown;
  }

  onNotificationDropdownVisibleChange(visible: boolean): void {
    this.showNotificationDropdown = visible;
  }

  onNotificationClick(notification: Notification): void {
    // Handle notification click - navigate to the relevant task/project
    
    // Navigate to task grid and open comments modal for the specific task
    if (notification.comment.targetType === 'Task') {
      const currentUrl = this.router.url;
      const targetRoute = '/task-grid';
      // Add timestamp to make each navigation unique
      const timestamp = Date.now();
      const queryParams = { 
        openComments: notification.comment.targetId,
        t: timestamp // Unique timestamp to force route change
      };
      
      if (currentUrl.includes(targetRoute)) {
        // Already on task grid, just update query params
        this.router.navigate([targetRoute], { 
          queryParams: queryParams
          // Don't specify queryParamsHandling to replace all params
        });
      } else {
        // Navigate to task grid with query params
        this.router.navigate([targetRoute], { 
          queryParams: queryParams
        });
      }
    }else if (notification.comment.targetType === 'TASK NOTIFICATION - RTC' ||notification.comment.targetType=="TASK NOTIFICATION") {
        const targetRoute = '/task-grid';
        // Add timestamp to make each navigation unique
        const timestamp = Date.now();
        const queryParams = { 
          taskId: notification.comment.targetId,
          type: notification.comment.targetType=== 'TASK NOTIFICATION - RTC' ? 'rtc' : 'notification', // Pass the type to differentiate in task grid
          t: timestamp // Unique timestamp to force route change
        };
        
        this.router.navigate([targetRoute], { queryParams: queryParams });
      } else if (notification.comment.targetType === 'PROJECT' || notification.comment.targetType === "PROJECT NOTIFICATION") {
        const targetRoute = '/projects';
        // Add timestamp to make each navigation unique
        const timestamp = Date.now();
        const queryParams = {
          projectId: notification.comment.targetId,
          t: timestamp // Unique timestamp to force route change
        };
        
        this.router.navigate([targetRoute], { queryParams: queryParams });
      }
    
  }
}
